<template>
  <section class="page-hero" :style="computedStyle">
    <div class="hero-background" v-if="hasBackgroundOverlay"></div>
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">{{ section.config.title }}</h1>
        <p class="hero-subtitle" v-if="section.config.subtitle">{{ section.config.subtitle }}</p>
        <div class="hero-buttons" v-if="section.config.buttons">
          <a 
            v-for="button in section.config.buttons" 
            :key="button.id"
            :href="button.link"
            :class="['btn', `btn-${button.style || 'primary'}`]"
          >
            {{ button.text }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageHero',
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  
  computed: {
    computedStyle () {
      const config = this.section.config
      let style = { ...config.style }
      
      // 处理背景类型
      if (config.backgroundType === 'gradient') {
        const { colors, direction } = config.backgroundConfig
        style.background = 'linear-gradient(' + direction + ', ' + colors.join(', ') + ')'
      } else if (config.backgroundType === 'image') {
        style.backgroundImage = 'url(' + config.backgroundConfig.url + ')'
        style.backgroundSize = config.backgroundConfig.size || 'cover'
        style.backgroundPosition = config.backgroundConfig.position || 'center'
      } else if (config.backgroundType === 'solid') {
        style.backgroundColor = config.backgroundConfig.color
      }
      
      return style
    },
    
    hasBackgroundOverlay () {
      return this.section.config.backgroundType === 'gradient'
    }
  }
}
</script>

<style scoped>
.page-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 30% 30%, rgba(124, 58, 237, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(6, 182, 212, 0.2) 0%, transparent 50%);
  pointer-events: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
  z-index: 1;
}

.hero-content {
  text-align: center;
}

.hero-title {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 800;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: clamp(1rem, 2.5vw, 1.25rem);
  opacity: 0.9;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .hero-buttons .btn {
    width: 100%;
    max-width: 300px;
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/sections/PageHero.vue